<template>
  <!-- 리펙토링 해야함 -->
  <div>
    <div v-if="renderType === 'normal'">
      <VBlock v-if="isOpen" id="modal-layer" :class="{ 'modal-layer': true, 'modal-default': true }">
        <component
          :is="modalName"
          :title="title"
          :message="message"
          :subMessage="subMessage || ''"
          :onOK="onOK"
          :onCancel="onCancel"
          :params="params"
        />
        <!-- </transition> -->
      </VBlock>
    </div>
    <div v-show="renderType !== 'normal'">
      <transition name="fade">
        <VBlock v-if="isOpen" class="overlay"></VBlock>
      </transition>
      <transition :name="renderType === 'normal' ? '' : renderType">
        <VBlock v-if="isOpen" id="modal-layer" :class="{ 'modal-default': true }" :sort="Sort.left_top">
          <component
            :is="modalName"
            :title="title"
            :message="message"
            :subMessage="subMessage || ''"
            :onOK="onOK"
            :onCancel="onCancel"
            :params="params"
          />
        </VBlock>
      </transition>
    </div>
    <!-- <div v-show="renderType === ''">
      <transition name="fade">
        <VBlock v-if="isOpen" class="overlay"></VBlock>
      </transition>
      <transition :name="renderType === 'normal' ? '' : renderType">
        <VBlock
          v-if="isOpen"
          id="modal-layer"
          :class="{'modal-default': true}"
          :sort="Sort.left_top"
        >
          <component
            :is="modalName"
            :title="title"
            :message="message"
            :onOK="onOK"
            :onCancel="onCancel"
            :params="params"
          />
        </VBlock>
      </transition>
    </div>-->
  </div>
</template>

<script>
import Vue from 'vue'
import upperFirst from 'lodash/upperFirst'
import camelCase from 'lodash/camelCase'

import VBlock, { Sort } from '@/presentationals/v2/components/layouts/molecules/VBlock'

const requireComponent = require.context('../../organisms/Modals/.', false, /[\w-].vue$/)

requireComponent.keys().forEach((fileName) => {
  const componentConfig = requireComponent(fileName)
  const componentName = upperFirst(camelCase(fileName.replace(/^\.\//, '').replace(/\.\w+$/, '')))
  Vue.component(componentName, componentConfig.default || componentConfig)
})

export default {
  name: 'ModalLayer',
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    renderType: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    subMessage: {
      type: String,
      required: true,
      default: ''
    },
    onOK: {
      type: Function,
      required: true
    },
    onCancel: {
      type: Function,
      required: true
    },
    params: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    VBlock
  },
  computed: {
    modalName() {
      return `Modal${this.type}`
    }
  },
  data() {
    return {
      Sort
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/modules/colors';

.overlay {
  position: fixed;
  z-index: 9999999;
  width: 100vw;
  height: 100vh;
  background-color: $overlay;
  box-sizing: border-box;
  transform: translateZ(0);
  will-change: transform;
}

.modal-default {
  position: fixed;
  z-index: 10000000;
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  transform: translateZ(0);
  will-change: transform;
}

.modal-layer {
  padding: 32px;
  background-color: $overlay;
}

@media screen and (max-width: 360px) {
  .modal-layer {
    padding: 16px;
  }
}

.full-slide-up-enter-active,
.full-slide-up-leave-active {
  transition: all 0.3s ease-in-out;
  transform: translate3d(0, 0, 0);
}

.full-slide-up-enter,
.full-slide-up-leave-to {
  transform: translate3d(0, 100vh, 0);
}

.full-fade-enter-active,
.full-fade-leave-active {
  transition: opacity 0.3s ease-in-out;
  opacity: 1;
}

.full-fade-enter,
.full-fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.1s ease-in-out;
  opacity: 1;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
